<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <div class="kt-form w-webkit-fill-available">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add Players — {{ data.groupName || 'new group' }}</h5>
                <span class="modal-x-button" (click)="onCloseDialog()"><i class="fa fa-times" aria-hidden="true"></i></span>
            </div>
            <div class="modal-body">
                <!-- One selection for both tabs, so it sits above them and survives every search. -->
                <div class="selected-box mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <span class="kt-font-bold">Selected ({{ picked.size | number : '1.0' }})</span>
                        <button type="button" class="btn btn-link btn-sm p-0" [disabled]="picked.size === 0" (click)="onUnpickAll()">Clear all</button>
                    </div>
                    <div *ngIf="picked.size; else nonePicked" class="selected-tags">
                        <span *ngFor="let c of pickedList; trackBy: trackById" class="selected-tag" [class.will-move]="willMove(c)"
                            [matTooltip]="willMove(c) ? 'Moves from ' + c.current_group_name : ''">
                            {{ c.username }} <small>({{ c.currency_code }})</small>
                            <i class="fas fa-times ml-1" (click)="onPick(c, false)"></i>
                        </span>
                    </div>
                    <ng-template #nonePicked><small class="text-muted">No players selected yet.</small></ng-template>
                </div>

                <mat-tab-group [(selectedIndex)]="tab" animationDuration="0ms">
                    <!-- SEARCH -->
                    <mat-tab label="Search">
                        <div class="row align-items-center mt-3">
                            <label class="col-2 col-form-label text-right">Username:</label>
                            <div class="col-4">
                                <input type="text" class="form-control" [(ngModel)]="filters.username" (keyup.enter)="onSearch()"
                                    placeholder="Search">
                            </div>
                            <label class="col-2 col-form-label text-right">Currency:</label>
                            <div class="col-4">
                                <select class="form-control" [(ngModel)]="filters.currency_id">
                                    <option value="all">All</option>
                                    <option *ngFor="let c of currencies" [value]="c.id">{{ c.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row align-items-center mt-2">
                            <label class="col-2 col-form-label text-right">Member Group:</label>
                            <div class="col-4">
                                <kt-dropdown-wo-lazyload
                                    [form]="groupForm"
                                    [formName]="'member_group_id'"
                                    [dropdownList]="memberGroups"
                                    [dropdownSettings]="groupSettings"
                                    [selectionAttributes]="'id'"
                                    [selectedItems]="groupSelected"
                                    (selectedItemsChanged)="onMemberGroupChanged($event)">
                                </kt-dropdown-wo-lazyload>
                            </div>
                        </div>

                        <!-- Search and Clear on the left, the page selection on the right: one action row. -->
                        <div class="d-flex justify-content-between align-items-center mt-3 mb-2">
                            <div>
                                <kt-search-button [loading]="searching" [disabledButton]="!canSearch" (search)="onSearch()"></kt-search-button>
                                <kt-clear-button [loading]="false" [disabledButton]="searching" (clear)="onClear()"></kt-clear-button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-secondary btn-sm mr-2" [disabled]="candidates.length === 0" (click)="onPickPage()">Select page</button>
                                <button type="button" class="btn btn-secondary btn-sm" [disabled]="!pagePicked" (click)="onUnpickPage()">Deselect page</button>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>ID</th>
                                        <th>Username</th>
                                        <th class="text-center">Currency</th>
                                        <th>Member Group</th>
                                        <th>Current group on {{ data.provider?.code }}</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="!searching">
                                    <tr *ngFor="let c of candidates; trackBy: trackById">
                                        <td class="text-center">
                                            <input type="checkbox" [disabled]="isMember(c)" [checked]="isMember(c) || picked.has(c.id)"
                                                (change)="onPick(c, $event.target.checked)">
                                        </td>
                                        <td>{{ c.id }}</td>
                                        <td>{{ c.username }}</td>
                                        <td class="text-center">{{ c.currency_code }}</td>
                                        <td>{{ c.member_group || '-' }}</td>
                                        <td>
                                            <span *ngIf="isMember(c)" class="text-muted">Already in this group</span>
                                            <span *ngIf="willMove(c)" class="kt-badge kt-badge--warning kt-badge--inline">{{ c.current_group_name }}</span>
                                            <span *ngIf="!c.current_group_id" class="text-muted">-</span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody shared-table-handler [loading]="searching" [dataLength]="searched ? candidates.length : 0"></tbody>
                            </table>
                        </div>
                        <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination && pagination.total > pagination.per_page">
                            <ngb-pagination [pageSize]="pagination.per_page" [(page)]="page" [maxSize]="5" [boundaryLinks]="true"
                                [rotate]="true" [collectionSize]="pagination.total" (pageChange)="onSearch(page)">
                            </ngb-pagination>
                            <div class="kt-pagination__toolbar">
                                <span class="pagination__desc">Showing {{ pagination.from || 0 }} to {{ pagination.to || 0 }} of {{ pagination.total | number : '1.0' }} players</span>
                            </div>
                        </div>
                    </mat-tab>

                    <!-- BULK LIST -->
                    <mat-tab label="Bulk List">
                        <div class="mt-3">
                            <label class="btn btn-default btn-sm mb-2">
                                <span>Choose CSV file</span>
                                <input type="file" hidden accept=".csv" (change)="onFile($event)">
                            </label>
                            <span class="ml-2 text-muted">{{ fileName || 'No file chosen' }}</span>
                            <span class="float-right">
                                <i class="fa fa-file-csv"></i>
                                <a href="assets/ExampleImportBetLimitPlayers.csv" target="_blank" download="ExampleImportBetLimitPlayers.csv"> Download Template</a>
                            </span>
                            <small class="form-text text-muted mt-0 mb-2">CSV only. For an Excel file, save it as CSV first. The first column is read as the username.</small>

                            <label class="control-label">…or paste usernames, one per line or comma separated</label>
                            <textarea class="form-control" rows="6" [(ngModel)]="bulkText" (ngModelChange)="bulkResult = null"></textarea>
                            <!-- mb-3: without it the button sits on the tab border. -->
                            <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
                                <small [class.text-danger]="bulkNames.length > maxBulk" class="text-muted">
                                    {{ bulkNames.length | number : '1.0' }} username(s){{ bulkNames.length > maxBulk ? ' — at most ' + (maxBulk | number : '1.0') + ' per check' : '' }}
                                </small>
                                <button type="button" class="btn btn-brand btn-sm" [disabled]="checking || bulkNames.length === 0 || bulkNames.length > maxBulk" (click)="onCheckList()">
                                    <i [class]="checking ? 'spinner-border spinner-border-sm align-middle' : 'fas fa-check'"></i>Check list
                                </button>
                            </div>

                            <div *ngIf="bulkResult" class="alert mt-3" [ngClass]="bulkResult.not_found.length || bulkMoveCount ? 'alert-warning' : 'alert-success'">
                                <div class="alert-text">
                                    <p class="m-0">
                                        <strong>{{ bulkResult.found.length | number : '1.0' }}</strong> found ·
                                        <strong>{{ bulkResult.not_found.length | number : '1.0' }}</strong> not found ·
                                        <strong>{{ bulkMoveCount | number : '1.0' }}</strong> will move from another group
                                        <ng-container *ngIf="bulkMemberCount"> · <strong>{{ bulkMemberCount | number : '1.0' }}</strong> already in this group</ng-container>
                                    </p>
                                    <p *ngIf="bulkResult.not_found.length" class="m-0"><small>Not found: {{ bulkResult.not_found.join(', ') }}</small></p>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onCloseDialog()">Cancel</button>
                <kt-submit-button [isDisabled]="picked.size === 0" [buttonLoading]="false" [text]="'Add to group (' + picked.size + ')'" (confirmed)="onConfirm()"></kt-submit-button>
            </div>
        </div>
    </div>
</div>
